<template>
  <div>
    <div v-if="subArrayItem.type == 'input'">
      <el-input v-model="subArrayItem.value" :placeholder="subArrayItem.placeholder"></el-input>
    </div>

    <div v-if="subArrayItem.type == 'checkboxgroup'" :key="n">
      <el-checkbox-group v-model="subArrayItem.value">
        <el-checkbox v-for="(checkbox,C) in subArrayItem.child" :label="checkbox.label" :key="C">{{checkbox.label}}</el-checkbox>
      </el-checkbox-group>
    </div>

    <div v-else-if="subArrayItem.type == 'select'">
      <el-select v-model="subArrayItem.value" style="width:100%">
        <el-option v-for="(_selects,j) in subArrayItem.child" :key="j" :label="_selects.label" :value="_selects.value"></el-option>
      </el-select>
    </div>

    <div v-else-if="subArrayItem.type == 'inputNumber'">
      <el-input-number v-model="subArrayItem.value" :min="0" :max="100" :step="1"></el-input-number>
    </div>

    <div v-else-if="subArrayItem.type == 'switch'" >
      <el-switch v-model="subArrayItem.value"></el-switch>
    </div>

    <div v-else-if="subArrayItem.type == 'checkbox'" >
      <el-checkbox v-model="subArrayItem.value">{{subArrayItem.name}}</el-checkbox>
    </div>

    <div v-else-if="subArrayItem.type == 'radioButton'" >
      <el-radio-group v-model="subArrayItem.value">
        <el-radio-button :label="group.value" v-for="(group,g) in subArrayItem.groups" :key="g">{{group.label}}</el-radio-button>
      </el-radio-group>
    </div>

    <template v-else-if="subArrayItem.list && subArrayItem.list.length>0">
      <div v-for="(res,r) in subArrayItem.list" :key="r">
        <span v-show="res.title">{{res.title}}</span>
        <widget-config-itme :sub-array-item="res" :select-index="selectIndex"></widget-config-itme>
      </div>
    </template>

    <template v-else-if="subArrayItem.arrays && subArrayItem.arrays.length>0">
      <div v-for="(arrayItme,arrayIndex) in subArrayItem.arrays" :key="arrayIndex">
        <!--数组设置输入框-->
        <div v-if="arrayItme.length>0 && Array.isArray(arrayItme)">
          <div v-for="(subArrayItem,subArrayItemIndex) in arrayItme" :key="subArrayItemIndex">
            <span v-show="subArrayItem.title">{{subArrayItem.title}}</span>
            <widget-config-itme :sub-array-item="subArrayItem" :select-index="selectIndex"></widget-config-itme>
          </div>

          <!--数组元素删除按钮-->
          <el-button @click="delXyjArray(selectIndex,arrayIndex)"
                     size="mini"
                     type="danger"
                     icon="el-icon-delete"
                     circle
                     :key="arrayIndex">
          </el-button>
        </div>
      </div>
      <div style="text-align:right">
        <el-button size='mini' type="primary" @click="addXyjArray(selectIndex)">添加数组元素</el-button>
      </div>
    </template>
  </div>
</template>

<script>
  import WidgetConfigItme from './WidgetConfigItme'
  export default {
    components: {
      WidgetConfigItme
    },
    name: "WidgetConfigItme",
    props: ['subArrayItem','selectIndex','data'],
    methods:{
      /**
       *宋建国：2020/1/10 12:43
      *描述：添加数组元素
      *版本：1.0
      */
      addXyjArray(index){
        let arraylen = this.subArrayItem.arrays.length;
        if(arraylen>0){
          let maxData = this.$tu.xyjClone(this.subArrayItem.arrays[arraylen-1]);
          this.subArrayItem.arrays.push(maxData);
        }
      },
      /**
       *宋建国：2020/1/10 13:08
      *描述：删除数组元素
      *版本：1.0
      */
      delXyjArray(index,i){
        this.subArrayItem.arrays.splice(i,1);
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/vueformmaking/WidgetConfigItme.vue